<app-skelton-confirmation-popup-with-svg>
    <div content [innerHTML] = 'popUpData.message'></div>
</app-skelton-confirmation-popup-with-svg>